<template>
  <rule-form
    v-if="rule"
    :rule="rule"
    @save="$emit('saved')"
    @cancel="$emit('canceled')"
  ></rule-form>
</template>
<script>
import documentModelMixin from "@/mixins/documentModel";
import RuleForm from "@/components/business-rules/RuleForm.vue";

export default {
  components: { RuleForm },
  mixins: [documentModelMixin],
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data: function() {
    return {
      rule: null,
    };
  },
  emits: ["saved", "canceled"],
  mounted: function() {
    this.rule = this.documentModel.businessRules.find((r) => r.id === this.id);
  },
};
</script>
